// Geteilte 3-Spalten-Live-Shell (Wireframes #2/#5/#8): Header + links (rollenspezifisch) /
// Mitte VIDEO / rechts CONFERENCE + optionale Action-Bar unten rechts (z. B. BEENDEN).
// Reine Layout-/Präsentations-Komponente — keinerlei Session-Logik.
import type { ReactNode } from 'react';
import { SessionHeader, type SessionStatus } from './SessionHeader';
import styles from './LiveShell.module.css';

export function LiveShell({ studio, title, status, token, headerRight, left, center, right, action }: {
  studio: string;
  title?: string;
  status?: SessionStatus;
  token?: string;
  headerRight?: ReactNode;
  left: ReactNode;
  center: ReactNode;
  right: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className={styles.shell}>
      <SessionHeader studio={studio} title={title} status={status} token={token} right={headerRight} />
      <div className={styles.body}>
        <aside className={styles.left}>{left}</aside>
        <section className={styles.center}>{center}</section>
        <aside className={styles.right}>
          {right}
          {action && <div className={styles.actionBar}>{action}</div>}
        </aside>
      </div>
    </div>
  );
}

// Uppercase-Spalten-Label (VOICE / STUDIO / VIDEO / CONFERENCE).
export function ColLabel({ children }: { children: ReactNode }) {
  return <div className={styles.colLabel}>{children}</div>;
}
